import React from 'react';
import { Container } from 'react-bootstrap';
import ProfileCard from '../../components/ProfileCard/ProfileCard';
import { getPaymentMethod } from '../../lib/graphql';
import { getAllPaymentMethodsQuery } from '../../lib/graphql';
import useQueryResponse from '../../lib/hooks/useQueryResponse';
import AddWalletForm from '../../components/AddWalletForm/AddWalletForm';

function AddWallet(props) {
    const { data: userPaymentMethod, loading: userPaymentMethodLoading } = useQueryResponse({
        query: getPaymentMethod,
        fetchPolicy: 'network-only',
        ssr: false

    })
    const { data: paymentMethods, loading: paymentMethodLoading } = useQueryResponse({
        query: getAllPaymentMethodsQuery,
        fetchPolicy: 'network-only',
        ssr: false
    })

    const { orderId, bookingId } = props;

    return (
        <div className={'subPageContainer'}>
            <Container>
                <div className='subPageWrapper'>
                    <ProfileCard />
                    <AddWalletForm paymentMethodLoading={paymentMethodLoading} paymentMethods={paymentMethods} userPaymentMethod={userPaymentMethod} orderId={orderId} bookingId={bookingId} />
                </div>
            </Container>
        </div>
    )
}

export default AddWallet